import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GiftUnlockExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { DropdownOption } from '../../../../../../shared/config/extension-ui-options';

@Component({
  selector: 'gift-unlock-offer-selling-plan',
  templateUrl: './gift-unlock-offer-selling-plan.component.html',
  styleUrls: ['./gift-unlock-offer-selling-plan.component.scss'],
  standalone: false,
})
export class GiftUnlockOfferSellingPlanComponent {
  @ViewChild('hideInCartLevel') hideInCartLevel: ElementRef<HTMLElement>;

  @Input() formGroup: UntypedFormGroup;
  @Input() couponTypeOptions: DropdownOption[];
  @Input() shopCurrencySymbol: string;
  @Input() isAutoApplyEnabled: boolean;

  CouponType = GiftUnlockExtension.CouponType;

  readonly hideInCartLevelOptions = [
    {
      value: GiftUnlockExtension.HideInCartLevel.PARENT_PRODUCT,
      label: 'Parent product only',
      description: 'Hide if any variant of the product is in cart',
    },
    {
      value: GiftUnlockExtension.HideInCartLevel.SPECIFIC_VARIANT,
      label: 'Specific variant only',
      description: 'Only hide the exact variant in cart (allow other variants)',
    },
  ];

  requiredFieldMessage = 'Required field';

  scrollToHideInCartLevel(): void {
    this.hideInCartLevel?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
